import { ClickType } from "@locent/types";

import { BaseComponent, BaseComponentAttrs } from "../base/baseComponent";
import { CompType } from "../base/baseEnum";

/** 宣传图接口 */
export interface PromoteAttrs extends BaseComponentAttrs {
  /** 标题 */
  title: string;
  /** H5 - 图片 */
  img_h5: string;
  /** PC - 图片 */
  img_pc: string;
  /** 点击参数 */
  click_params: string;
  /** 点击ID */
  click_id: ClickType;
}

/** 宣传图组件类 */
export class PromoteComponent extends BaseComponent<PromoteAttrs> {
  constructor(data: Partial<BaseComponent<PromoteAttrs>> = {}) {
    super(data);
    this.type = CompType.promote;
  }

  /* H5 图片连结 */
  public getH5ImgUrl(): string {
    return this?.lang_attrs?.img_h5;
  }

  /* PC 图片连结 */
  public getPcImgUrl(): string {
    return this?.lang_attrs?.img_pc;
  }

  /* 点击事件id */
  public getClickId(): number {
    return this?.lang_attrs?.click_id;
  }

  /* 点击事件参数 */
  public getClickParams(): string {
    return this?.lang_attrs?.click_params;
  }
}
